<template>
    <div name="complete-modal" class="modal">
        <div class="touch" @click="onClose">

        </div>
        <div class="contents" v-if="!isError">
            <span class="title">환자 등록 완료</span>
            <span class="error">환자 정보 등록이 완료되었습니다.</span>
            <span class="error">병원 예약 또는 서비스 관련 궁금한 사항은<br/> 고객센터(02-6954-7682)로 문의해주세요.</span>
            <div class="button2" @click="onKakao">
            확인</div>
        </div>
        <div class="contents" v-else>
            <span class="title">{{title}}</span>
            <span class="error">{{ message }}</span>
            <span class="error">고객센터(02-6954-7682)로 문의해주세요.</span>
            <div class="button2" @click="onKakao">
                확인</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'completeModal',
    props: ['isError', 'title', 'message'],
    methods: {
        onKakao: function()
        {
            // window.open("http://pf.kakao.com/_xoDxeJG/chat", "_blank")
            this.$emit('onClose')
        },
        onClose: function()
        {
            this.$emit('onClose')
        }
    }
}
</script>

<style scoped>
.wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        height: 100vh;
        z-index: 10;
        bottom: 0;
    }
    .touch {
        height: calc(100vh - 328px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 328px;
        width: calc(100% - 16px);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding-top: 34px;
        padding-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }

    .error {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
        margin-top: 20px;
    }
    .button2 {
        display: flex;
        width: calc(100% - 32px);
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        position: absolute;
        bottom: 30px;
        cursor: pointer;
    }
    
    .button {
        display: flex;
        width: calc(100% - 32px);
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid var(--Gray-50, #A3AAB6);
        background: #FFE601;
        text-align: center;
        color: #1E1E1E;

        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.54px;
        position: absolute;
        bottom: 30px;
        cursor: pointer;
    }
    .icon{
        width: 24px;
        margin-right: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/CompleteModal.vue